export const OAUTH2_SOCIAL_CALLBACK_URI = `${window.location.origin}/login/callback`;
export const OAUTH2_PKCE_CHALLENGE_LENGTH = 64;
